import { render, staticRenderFns } from "./defaultTable - 副本.vue?vue&type=template&id=e169171c"
import script from "./defaultTable - 副本.vue?vue&type=script&lang=js"
export * from "./defaultTable - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports